import { render } from "./ContactInformationStepComponent.vue?vue&type=template&id=8524cc8a&ts=true"
import script from "./ContactInformationStepComponent?vue&type=script&lang=ts"
export * from "./ContactInformationStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__